module.exports = {
    "frames": [
        {
            "time": 0,
            "image": require("@frog/source/assets/images/bomber-tactics/units/yellow/p-push-yellow/p-push-yellow1_.png").default
        },
        {
            "time": 100,
            "image": require("@frog/source/assets/images/bomber-tactics/units/yellow/p-push-yellow/p-push-yellow2_.png").default
        },
        {
            "time": 200,
            "image": require("@frog/source/assets/images/bomber-tactics/units/yellow/p-push-yellow/p-push-yellow3_.png").default
        },
        {
            "time": 300,
            "image": require("@frog/source/assets/images/bomber-tactics/units/yellow/p-push-yellow/p-push-yellow4_.png").default
        },
        {
            "time": 400,
            "image": require("@frog/source/assets/images/bomber-tactics/units/yellow/p-push-yellow/p-push-yellow5_.png").default
        },
        {
            "time": 500,
            "image": require("@frog/source/assets/images/bomber-tactics/units/yellow/p-push-yellow/p-push-yellow6_.png").default
        },
        {
            "time": 600,
            "image": require("@frog/source/assets/images/bomber-tactics/units/yellow/p-ready-yellow/p-ready-yellow1_.png").default
        }
    ]
}
